import i18n from '@/lang'

export default function getPageTitle(pageTitle) {
  const title = i18n.te('logo_title') ? i18n.t('logo_title') : ''
  if (!pageTitle) {
    return title
  }
  const hasKey = i18n.te(pageTitle)
  if (hasKey) {
    const pageName = i18n.t(pageTitle)
    return `${pageName} | ${title}`
  }
  return `${pageTitle} | ${title}`
}
